import ApiService from "./api.service";

class BulletinService extends ApiService {
    getBulletins() {
        return this.get(`api/meeting/bulletin`);
    }

    getLatestBulletinItem() {
        return this.get(`api/meeting/bulletin/latest`);
    }

    updateClickStats(id) {
        return this.post(`api/meeting/bulletin/${id}/update-click-stats`);
    }
}

export default new BulletinService();
